import React from 'react';
import Typography from '@material-ui/core/Typography';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';

import { colors } from '../../../../../../themes/colors';
import { ProviderSessionTimeTestID } from './constants';

interface ProviderSessionTimeProps {
  endTime: string;
  startTime: string;
}

const styles = (theme) =>
  createStyles({
    sessionTime: {
      fontSize: 14,
      color: colors.black4,
      width: 200,
    },
  });

type Props = WithStyles<typeof styles> & ProviderSessionTimeProps;

const ProviderSessionTime: React.FC<Props> = ({ classes, endTime, startTime }) => (
  <div data-testid={ProviderSessionTimeTestID}>
    <Typography className={classes.sessionTime}>{`${startTime} - ${endTime}`}</Typography>
  </div>
);

export default withStyles(styles)(ProviderSessionTime);
